<!-- 问卷创建方式之---文本导入页面 -->
<template>
    <div class="create-text-import">
        <el-row type="flex" justify="space-between" align="middle">
            <go-back content="文本导入"/>
            <el-button type="primary" size="small"
                       @click.stop="handleSave"
                       :loading="isCreating"
                       style="min-width: 120px">
                创建项目
            </el-button>
        </el-row>
        <!-- container -->
        <el-row type="flex" justify="space-between">
            <!-- 输入区域 -->
            <input-area
                ref="inputArea"
                @matchTitle="onMatchTitle"
                @matchWelcome="onMatchWelcome"
                @matchQuestion="onMatchQuestion"
            />
            <!-- 展示区 -->
            <view-area :view="view"/>
        </el-row>
    </div>
</template>

<script>
import InputArea from "./cpns/input"
import ViewArea from "./cpns/view"
import { TITLE, WELCOME, QUESTION_NUM } from "@/utils/question-config";
import { addQuestion } from "@/api/new-question-iteration/question-library"

export default {
    name: "CreateTextImport",
    components: {
        InputArea,
        ViewArea
    },
    data() {
        return {
            // 检查区域文本
            view: {
                title: TITLE, // 问卷项目标题
                welcome: WELCOME, // 欢迎语
                questionList: [], // 试题列表
            },
            isCreating: false
        }
    },
    computed: {
    },
    methods: {
        // 赋值项目标题
        onMatchTitle(val) {
            if (val === this.view.title) return
            this.view.title = val
        },
        // 匹配项目欢迎语
        onMatchWelcome(val) {
            if (val === this.view.welcome) return
            this.view.welcome = val
        },
        // 匹配问卷题型
        onMatchQuestion(questionList) {
            this.view.questionList = questionList
        },
        // 处理创建项目
        handleCreate() {
            const status = this.$refs.inputArea.getChainStatusAndAlertMessage()
            const { title, welcome, questionList } = this.view
            if (status === "success") {
                this.isCreating = true
                addQuestion({
                    Name: title,
                    Title: welcome,
                    Details: questionList.map(item => ({
                        Type: QUESTION_NUM[item.type],
                        Title: item.stem, // 题干
                        Remark: "", // 备注
                        IsMustAnswer: 0, // 是否必答,
                        Options: Array.isArray(item.options) ? item.options.map(item => item.text).join("|") : item.options
                    })),
                    Tag: ""
                }).then(res => {
                    this.isCreating = false
                    this.$message.success("创建成功")
                    this.$router.replace({
                        name: "CreateEmpty",
                        query: {
                            Qid: res,
                            from: "/manage/psq"
                        }
                    })
                }).catch(e => {
                    this.isCreating = false
                })
            }
        },
        // 处理保存
        handleSave () {
            this.handleCreate()
        }
    }
}
</script>

<style scoped lang="less">

.create-text-import {
    width: 76%;
    margin: 40px auto 0;
}
</style>
